<template>
  <div>
    <div class="activity-cell" v-for="(item, index) in list" :key="index">
      <div class="activity-cell-wrap">
        <a :href="'/activity/chinese/'+item.id" target="_blank" class="activity-cell-wrap-left" v-if="item.activity_img && item.activity_img.length > 0">
          <img :src="getSingleImagePath(item.activity_img)" alt="">
        </a>
        <div class="activity-cell-wrap-right">
          <a :href="'/activity/chinese/'+item.id" target="_blank" class="activity-cell-wrap-right-link">
            {{ item.activity_name }}
          </a>
          <div class="activity-cell-wrap-right-box">
            <div class="activity-cell-wrap-right-box-cell">
              时间：{{ convertTime(item.activity_start_time, item.activity_end_time) }}
            </div>
            <div class="activity-cell-wrap-right-box-cell">
              地点：{{ item.activity_address }}
            </div>
          </div>
        </div>
      </div>
      <div class="activity-cell-footer">
        <span>{{ $moment(item.updated_at || item.created_at).format("YYYY-MM-DD") }}</span>
        <span class="space" v-if="item.activity_class && item.activity_class.class_name">|</span>
        <span>{{ item.activity_class && item.activity_class.class_name ? item.activity_class.class_name : '' }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ActivityCell',
  props: {
    // 数据列表
    list: {
      type: Array,
      default() {
        return []
      }
    },
  },
  methods: {
    // 获取图片地址
    getSingleImagePath(rows) {
      let str = "";
      if (rows && rows.length > 0) {
        str = rows[0]['img'];
      }
      return str;
    },
    // 处理活动开始时间
    convertTime(start_time, end_time) {
      let now_str = ""
      if (start_time && end_time) {
        const startMoment = this.$moment(start_time);
        const endMoment = this.$moment(end_time);
        const isSameDay = startMoment.isSame(endMoment, 'day');
        // 同一天
        if (isSameDay) {
          now_str = `${startMoment.format('YYYY年MM月DD日 HH:mm')}～${endMoment.format('HH:mm')}`;
        } else {
          now_str = `${startMoment.format('YYYY年MM月DD日 HH:mm')}～${endMoment.format('YYYY年MM月DD日 HH:mm')}`;
        }
      }
      return now_str;
    }
  }
}
</script>
<style lang="scss" scoped>
.activity-cell {
  padding: 24px 0;
  border-top: 1px solid #e9e9e9;
  font-family: HarmonyOS_Sans_Regular;
  &-wrap {
    display: flex;
    &-left {
      margin-right: 20px;
      line-height: 0;
      display: inline-block;
      img {
        max-width: 213px;
      }
    }
    &-right {
      &-link {
        color: #0B0B0B;
        font-size: 20px;
        font-family: HarmonyOS_Bold;
        text-decoration: none;
        display: inline-block;
      }
      &-box {
        margin-top: 20px;
        &-cell {
          font-size: 13px;
          &:nth-child(2n) {
            margin-top: 10px;
          }
        }
      }
    }
  }
  &-footer {
    margin-top: 35px;
    font-size: 12px;
    color: #747474;
    .space {
      margin: 0 15px;
    }
  }
}
/* 针对平板 */
@media screen and (min-width: 768px) and (max-width: 1024px) {}
/* 针对手机 */
@media screen and (max-width: 767px) {
  .activity-cell {
    &-wrap {
      flex-direction: column;
      &-left {
        margin-right: 0;
        margin-bottom: 20px;
        img {
          max-width: 100%;
        }
      }
    }
  }
}
</style>
